var exports = {
  "kL": "KeybindsTab.module__container___UFZtZU",
  "ft": "KeybindsTab.module__containerCompact___UFZtZU",
  "Pc": "KeybindsTab.module__searchRow___UFZtZU",
  "Vw": "KeybindsTab.module__customSection___UFZtZU",
  "P_": "KeybindsTab.module__customHeader___UFZtZU",
  "yy": "KeybindsTab.module__customHeaderText___UFZtZU",
  "_U": "KeybindsTab.module__customTitle___UFZtZU",
  "Mu": "KeybindsTab.module__customSubtitle___UFZtZU",
  "DK": "KeybindsTab.module__shortcutOptions___UFZtZU",
  "sC": "KeybindsTab.module__shortcutOption___UFZtZU",
  "wm": "KeybindsTab.module__customList___UFZtZU",
  "Kl": "KeybindsTab.module__customRow___UFZtZU",
  "YI": "KeybindsTab.module__customRowDisabled___UFZtZU",
  "Of": "KeybindsTab.module__customHeaderActions___UFZtZU",
  "DN": "KeybindsTab.module__dotsButton___UFZtZU",
  "D2": "KeybindsTab.module__customRowMain___UFZtZU",
  "EG": "KeybindsTab.module__customField___UFZtZU",
  "gF": "KeybindsTab.module__customFieldLabel___UFZtZU",
  "Ou": "KeybindsTab.module__customControls___UFZtZU",
  "dD": "KeybindsTab.module__customHint___UFZtZU",
  "p$": "KeybindsTab.module__emptyState___UFZtZU",
  "Z8": "KeybindsTab.module__conflictWarning___UFZtZU",
  "se": "KeybindsTab.module__conflictIcon___UFZtZU",
  "rs": "KeybindsTab.module__defaultsList___UFZtZU",
  "WX": "KeybindsTab.module__defaultsSection___UFZtZU",
  "Mz": "KeybindsTab.module__defaultsSectionTitle___UFZtZU",
  "DC": "KeybindsTab.module__defaultsSectionRows___UFZtZU",
  "Bq": "KeybindsTab.module__defaultChipsMerged___UFZtZU",
  "r1": "KeybindsTab.module__defaultChips___UFZtZU",
  "_R": "KeybindsTab.module__defaultRow___UFZtZU",
  "pc": "KeybindsTab.module__defaultRowActions___UFZtZU",
  "AB": "KeybindsTab.module__defaultLabel___UFZtZU",
  "q3": "KeybindsTab.module__defaultChipsEmpty___UFZtZU",
  "Oo": "KeybindsTab.module__defaultChip___UFZtZU",
};

module.exports = exports;
